"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Popout = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M6 4h4v2H6v12h12v-4h2v4a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2zm7 0v2h3.578l-7.553 7.554 1.414 1.414L18 7.407V11h2V5a1 1 0 00-1-1h-6z"
      }
    )
  );
};
export default Popout;
